import {
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import { KPretty } from '../../../services/utils'
import { OptionalTag } from '../OptionalTag'
import { SkyInformationPopover } from '../../Core/Popover/SkyPopover'
import { SkywatchSlider } from '../../Core/Buttons/SkywatchSlider'

export const Section = ({
  title,
  subtitle,
  error,
  optional,
  tooltip = undefined,
  children,
  isDivider = true,
}) => {
  return (
    <>
      <Grid
        container
        alignItems={'center'}
        justify={'space-between'}
        spacing={2}>
        <Grid item xs={12} md={5}>
          <FlexView vAlignContent={'center'}>
            <div className="text-body black bolder margin-right-6">{title}</div>
            {tooltip && (
              <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
                <div className="text-small">{tooltip}</div>
              </SkyInformationPopover>
            )}
            {optional && <OptionalTag />}
          </FlexView>
          <div className="text-small gray margin-top-small">{subtitle}</div>
        </Grid>
        <Grid item xs={12} md={7}>
          <FlexView className="space-between">
            <div />
            <div>{children}</div>
          </FlexView>
        </Grid>
      </Grid>
      {error?.message && <div className="text-body red">{error?.message}</div>}
      {isDivider && <Divider />}
    </>
  )
}

export const SectionTria = ({
  title,
  subtitle,
  viewTria,
  triaURL,
  optional,
  tooltip = undefined,
}) => {
  return (
    <>
      <Grid
        container
        alignItems={'center'}
        justify={'space-between'}
        spacing={2}>
        <FlexView vAlignContent={'center'}>
          <div className="text-body black margin-right-6 margin-top-medium">
            {title}
          </div>
          {tooltip && (
            <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
              <div className="text-small">{tooltip}</div>
            </SkyInformationPopover>
          )}
          {optional && <OptionalTag />}
        </FlexView>
        <div className="text-small gray margin-top-small">{subtitle}</div>
        <a
          className="text-small gray margin-top-small margin-bottom-medium"
          href={triaURL}
          target="_blank"
          rel="noreferrer noopener">
          {viewTria}
        </a>
      </Grid>
    </>
  )
}

export const SectionRadioButton = ({
  name,
  value,
  buttons,
  errors = {},
  onChange,
  ...props
}) => {
  return (
    <>
      <Section error={errors[name]} {...props}>
        <RadioGroup
          value={value}
          onChange={(e) => onChange(name, e.target.value)}>
          <FlexView>
            {buttons.map((btn, index) => (
              <FormControlLabel
                key={index}
                label={btn.label}
                value={btn.value}
                control={<Radio color="primary" />}
              />
            ))}
          </FlexView>
        </RadioGroup>
      </Section>
    </>
  )
}

export const SectionSelect = ({
  name,
  value,
  buttons,
  KPretty = false,
  errors = {},
  onChange,
  divide = true,
  disabled = false,
  ...props
}) => {
  if (!value) return <div />
  return (
    <>
      <Section isDivider={divide} error={errors[name]} {...props}>
        <Select
          variant="outlined"
          value={value}
          onChange={(e) => onChange && onChange(name, e.target.value)}>
          {buttons.map((btn, index) => (
            <MenuItem key={index} value={btn.value}>
              <div className="text-body black">{btn.label}</div>
            </MenuItem>
          ))}
        </Select>
      </Section>
    </>
  )
}

export const SectionSlider = ({
  name,
  marks,
  min,
  max,
  value,
  step,
  options,
  errors = {},
  onChange,
  divider = true,
  disabled = false,
  ...props
}) => {
  let defValue = 0
  try {
    defValue = Number(options.find((opt) => opt.value == value).label.slice(1))
  } catch {}
  let currentValueLabel = options.find((opt) => opt.value == value)

  return (
    <>
      <div className="margin-bottom-basic">
        <FlexView vAlignContent={'center'}>
          <div className="text-body black bolder margin-right-6">
            {props.title}
          </div>
          {props.tooltip && (
            <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
              <div className="text-small">{props.tooltip}</div>
            </SkyInformationPopover>
          )}
        </FlexView>
        <div className="text-small gray margin-top-small">{props.subtitle}</div>
      </div>
      {currentValueLabel && (
        <div className="text-small blue bold">
          {currentValueLabel.label[0] +
            Number.parseInt(currentValueLabel.label.slice(1)).toLocaleString()}
        </div>
      )}
      <SkywatchSlider
        defaultValue={defValue}
        value={defValue}
        textFormatFunction={(v) => KPretty(v)}
        onValueChange={(v) => onChange(name, v)}
        min={min}
        marks={marks}
        step={null}
        disabled={disabled}
        max={max}
      />
      {errors[name] && (
        <div className="text-body red">{errors[name].message}</div>
      )}
      {divider && <Divider />}
    </>
  )
}

export const SectionSpecialSelect = ({
  name,
  value,
  buttons,
  errors = {},
  onChange,
  ...props
}) => {
  if (!!!value) return <div />
  return (
    <>
      <Section error={errors[name]} {...props}>
        <Select
          variant="outlined"
          value={value}
          onChange={(e) => onChange && onChange(name, e.target.value)}>
          {buttons.map((btn, index) => (
            <MenuItem key={index} value={btn.value}>
              <FlexView>
                {btn.labels ? (
                  [...btn.labels].reverse().map((label, eIndex) => (
                    <div
                      className="margin-right-small margin-left-small"
                      key={`${index}${eIndex}`}>
                      <div className="text-body black">{label}</div>
                      <div className="text-body black bold textcenter">
                        {[...btn.values].reverse()[eIndex]}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-body black">{btn.label}</div>
                )}
              </FlexView>
            </MenuItem>
          ))}
        </Select>
      </Section>
    </>
  )
}
